import { Image, Spin, Typography } from "antd";
import axios from "axios";
import { ComponentProps, useEffect, useState } from "react";
import { LoginAPIHelper } from "../../api-helpers/LoginAPIHelper";

type AuthenticatedImageProps = Omit<
  ComponentProps<typeof Image>,
  "src"
> & {
  src: string;
};

function AuthenticatedImage({ src, alt, ...props }: AuthenticatedImageProps) {
  const [objectUrl, setObjectUrl] = useState<string>();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    let createdUrl: string | undefined;

    setObjectUrl(undefined);
    setFailed(false);

    axios
      .get(src, {
        headers: LoginAPIHelper.getAuthHeader(),
        responseType: "blob",
      })
      .then((response) => {
        if (!active) {
          return;
        }

        createdUrl = URL.createObjectURL(response.data);
        setObjectUrl(createdUrl);
      })
      .catch(() => {
        if (active) {
          setFailed(true);
        }
      });

    return () => {
      active = false;
      if (createdUrl) {
        URL.revokeObjectURL(createdUrl);
      }
    };
  }, [src]);

  if (failed) {
    return (
      <Typography.Text type="danger">
        {alt || "Unable to load image."}
      </Typography.Text>
    );
  }

  if (!objectUrl) {
    return <Spin size="small" />;
  }

  return <Image {...props} src={objectUrl} alt={alt} />;
}

export default AuthenticatedImage;
